<template>
  <div class="w-full">
    <div
      class="container mx-auto grid md:grid-cols-3 gap-5 lg:gap-8 place-items-start mb-10"
    >
      <template v-for="article in knowledgeStore.articles">
        <KnowledgeArticleCard
          v-if="article?.slug !== 'knowledge'"
          :key="article.uuid"
          :article="article.content"
          :slug="article.full_slug"
        />
      </template>
    </div>

    <nav
      class="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6"
      aria-label="Pagination"
    >
      <div class="hidden sm:block">
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium">{{ knowledgeStore.from }}</span>
          to
          <span class="font-medium">{{ knowledgeStore.to }}</span>
          of
          <span class="font-medium">{{ knowledgeStore.numberOfArticles }}</span>
          articles
        </p>
      </div>
      <div class="flex flex-1 justify-between sm:justify-end">
        <NuxtLink
          rel="prev"
          v-if="knowledgeStore.showPreviousButton()"
          :to="`${basePath}${currentPage - 1}`"
          class="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
        >Previous</NuxtLink>
        <NuxtLink
          rel="next"
          v-if="knowledgeStore.showNextButton()"
          :to="`${basePath}${currentPage + 1}`"
          class="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
        >Next</NuxtLink>
      </div>
    </nav>
  </div>
</template>

<script setup>
const props = defineProps({
  category: String,
});

const knowledgeStore = useKnowledgeStore();
const route = useRoute();

// Get current page from URL or default to 1
const currentPage = computed(() => Number(route.query.page) || 1);

// Compute the base path including any category
const basePath = computed(() => {
  const base = route.path;
  return `${base}?page=`;
});

await useAsyncData('knowledge', async () => {
  await knowledgeStore.fetchCategories();
  await knowledgeStore.fetchArticles(currentPage.value, props.category || '');
});

watch(
  () => route.query.page,
  async (newPage) => {
    window.scrollTo(0, 0);

    await knowledgeStore.fetchArticles(
      currentPage.value,
      knowledgeStore.categoryFilter
    );
  }
);
</script>
